import { targetService, $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {
  SET_TARGET_REFERENCES
} from './mutationTypes';

import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_SUCCESS, SET_ACTION_STATUS_ERROR } from '@/store/helpers';

const actions = {
  async getTargetReferences({ rootState, commit }, targetId) {
    commit(SET_TARGET_REFERENCES, []);
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'getTargetReferences' });
    try {
      const response = await targetService.getTargetReferences(rootState.currentAccountId, targetId);
      // Unify logic
      const references = [];
      if (response.data.campaigns) {
        references.push(...response.data.campaigns.map(campaign => {
          return {
            type: 'Campaign Routing',
            name: campaign.campaignName,
            id: campaign.campaignId,
            link: $ngStateService.href('dashboard.campaign', { campaignId: campaign.campaignId }, { absolute: true })
          };
        }));
      }

      if (response.data.callplans) {
        references.push(...response.data.callplans.map(callplan => {
          return {
            type: 'Call Flow Routing Plan',
            name: callplan.callplanName,
            id: callplan.callplanId,
            link: $ngStateService.href('dashboard.call-plans.edit', { callPlanId: callplan.callplanId }, {absolute: true})
          };
        }));
      }

      if (response.data.targetgroups) {
        references.push(...response.data.targetgroups.map(targetgroup => {
          return {
            type: 'Target Group',
            name: targetgroup.targetgroupName,
            id: targetgroup.targetgroupId,
            link: $ngStateService.href('dashboard.targetgroup.edit', { targetGroupId: targetgroup.targetgroupId }, {absolute: true})
          };
        }));
      }
      commit(SET_TARGET_REFERENCES, references);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'getTargetReferences' });
    } catch (e) {
      commit(SET_TARGET_REFERENCES, []);
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'getTargetReferences', error: e });
    }

  },
  async validateTargetNumber({ rootState, commit }, number) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: 'validateTargetNumber', result: {} });
    try {
      const response = await targetService.validateTargetNumber(rootState.currentAccountId, number);
      const numberValidation = response.data.numberValidation;
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: 'validateTargetNumber', result: numberValidation });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: 'validateTargetNumber', error: e, result: {} });
    }
    

  }
};

export default actions;